import React from 'react';
import { useSubjects } from '../../contexts/SubjectsContext';
import SubjectCard from './SubjectCard';

const SubjectsList = () => {
  const { filteredSubjects, loading } = useSubjects();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#9a6ebd] border-t-transparent"></div>
      </div>
    );
  }

  if (filteredSubjects.length === 0) {
    return (
      <div className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-100">
        <p className="text-gray-600">Aucun sujet ne correspond à vos critères.</p>
        <p className="text-sm text-gray-500 mt-2">Essayez de modifier vos filtres de recherche.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {filteredSubjects.map((subject) => (
        <SubjectCard key={subject.id} subject={subject} />
      ))}
    </div>
  );
};

export default SubjectsList;